import { setPageClasses } from "./utils";
import "../vendor/gsap/gsap.min";
import "../vendor/gsap/ScrollToPlugin.min";
import ScrollTrigger from "../vendor/gsap/ScrollTrigger.min";

window.addEventListener("phx:page-loading-start", () => {
  setPageClasses();
});

window.addEventListener("phx:page-loading-stop", info => {
  if (info.detail.kind !== "element") {
    setPageClasses();
    document.body.classList.remove("mobile-nav-open");

  }

  if (info.detail.kind === "redirect") {
    // Motomo needs to be notified on history api state changes
    gsap.delayedCall(1, () => {
      window._paq.push(["setCustomUrl", window.location.href]);
      window._paq.push(["setDocumentTitle", window.document.title]);
      window._paq.push(["trackPageView"]);
      window._paq.push(["enableLinkTracking"]);
    });
  }
});

window.addEventListener("open-dialog", ({ detail }) => {
  const dialogEl = detail.dispatcher;

  dialogEl.showModal();

  dialogEl.addEventListener("cancel", e => {
    e.preventDefault();

    if (dialogEl) {
      const event = dialogEl.querySelector(".close-dialog").getAttribute("phx-click");
      window.liveSocket.execJS(dialogEl, event);
    }
  });

  dialogEl.addEventListener("click", event => {
    if (dialogEl && event.target === event.currentTarget) {
      const event = dialogEl.querySelector(".close-dialog").getAttribute("phx-click");
      window.liveSocket.execJS(dialogEl, event);
    }
  });
});

window.addEventListener("open-member-dialog", ({ detail }) => {
  if (ScrollTrigger.isTouch === 1) {
    const event = detail.dispatcher.dataset.openDialog
    window.liveSocket.execJS(detail.dispatcher, event);
  }
});

window.addEventListener("open-partner-dialog", ({ detail }) => {
  if (ScrollTrigger.isTouch === 1) {
    const event = detail.dispatcher.dataset.openDialog
    window.liveSocket.execJS(detail.dispatcher, event);
  }
});

window.addEventListener("close-dialog", ({ detail }) => {
  detail.dispatcher.close();
});

window.addEventListener("scroll-to", ({ detail }) => {
  const headerEl = document.querySelector("#header")
  const smoother = ScrollSmoother.get();
  let headerHeight = 0;

  if (headerEl) { headerHeight = headerEl.offsetHeight; }

  function scrollTo(offset) {
    if (smoother) {
      smoother.scrollTo(`#${detail.id} .wrapper`, true);
    }
    else {
      gsap.to(window, {duration: 0.3, scrollTo: {y: `#${detail.id} .wrapper`, offsetY: offset}});
    }
  }

  scrollTo(headerHeight);
  gsap.delayedCall(0.3, () => scrollTo(headerHeight));
});

window.addEventListener("phx:update-cookie-consent", ({ detail }) => {
  localStorage.setItem("cookie_consent", JSON.stringify(detail));
});

window.addEventListener("nav:share_url", ({ detail }) => {
  const current_page = encodeURIComponent(document.location.href);
  const text = encodeURIComponent("I'd like to share this page.");
  const full_text = encodeURIComponent(`I'd like to share this page: ${document.location.href}`);
  const document_title = encodeURIComponent(document.title);
  let url;

  switch (detail.type) {
    case "linkedin":
      url = `https://www.linkedin.com/sharing/share-offsite/?url=${current_page}`;
      break;
    case "x":
      url = `https://x.com/intent/tweet?text=${text}&url=${current_page}`;
      break;
    case "facebook":
      url = `https://www.facebook.com/sharer/sharer.php?u=${current_page}`;
      break;
    case "whatsapp":
      url = `https://api.whatsapp.com/send?text=${full_text}`;
      break;
    case "pinterest":
      url = `https://www.pinterest.com/pin/create/button/?url=${current_page}&description=${text}&media=${detail.media}`
      break;
    case "reddit":
      url = `https://reddit.com/submit?url=${current_page}&title=${document_title}`;
      break;
    case "email":
      url = `mailto:?body=${full_text}&subject=${document_title}`
      break;
  }

  window.open(url, "", "menubar=no,toolbar=no,scrollbars=yes,resizable=yes,height=600,width=600");
});

window.addEventListener("phx:window-alert", ({detail}) => {
  alert(detail.message);
});
